import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import ModalCenter1 from "../Modals/modal1";
import ModalCenter2 from "../Modals/modal2";
import { Rating } from "@mui/material";

export default function FormDepoy() {
  const [name, setName] = useState("");
  const [rating, setRating] = useState("");
  const [avaliation, setAvaliation] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalTrue, setShowModalTrue] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();

    if (name === "" || rating === "" || avaliation === "") {
      setShowModal(true)
    }
    if (name !== "" || rating !== "" || avaliation !== "") {
        setShowModalTrue(true);
    }

    axios
      .post("https://valentin-api.vercel.app/save-depoyments", {
        name: name,
        rating: rating,
        avaliation: avaliation,
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <Form className="form" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Nome:</Form.Label>
        <Form.Control
          type="text"
          placeholder="Informe seu nome"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Avaliação:</Form.Label>
        <Rating name="simple-controlled" value={rating} onChange={(event) => setRating(event.target.value)}/>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Depoimento:</Form.Label>
        <Form.Control
          as="textarea"
          value={avaliation}
          placeholder="Descreva sua experiência conosco"
          onChange={(event) => setAvaliation(event.target.value)}
        />
      </Form.Group>
      <Button type="submit">Publicar</Button>
      <ModalCenter1 show={showModalTrue} onHide={() => setShowModalTrue(false)} />
      <ModalCenter2 show={showModal} onHide={() => setShowModal(false)} />
    </Form>
  );
}
